import * as React from 'react'
import Head from 'next/head'
import {
  HeaderService,
} from '../../services'
import GTM from './GoogleTagManager'
import { CONTENT } from '../../const/content';
import ContentComponent from './ContentComponent';
import { SETTING } from '../../const/setting';
import { loadImage } from '../../util/image';
declare const $;

function generateMetaTag(metaTags) {
  let metaTagArray: any = []
  metaTags.forEach((metaTag, index) => {
    let props = {}
    if (metaTag.name) props['name'] = metaTag.name
    if (metaTag.httpEquiv) props['httpEquiv'] = metaTag.httpEquiv
    if (metaTag.charset) props['charSet'] = metaTag.charset
    if (metaTag.property) props['property'] = metaTag.property
    if (metaTag.content) props['content'] = metaTag.content
    metaTagArray.push(<meta key={getMetaTagKey(metaTag, index)} {...props} />)
  })

  return metaTagArray
}

function getMetaTagKey(metaTag, index) {
  if (metaTag.name) return `name:${metaTag.name}`
  if (metaTag.property) return `property:${metaTag.property}`
  if (metaTag.httpEquiv) return `httpEquiv:${metaTag.httpEquiv}`
  if (metaTag.charset) return 'charSet'
  return `meta:${index}`
}

export default class extends React.Component<any, any> {
  constructor(props) {
    super(props)
  }

  static async getInitialProps() {

    const header = await HeaderService.getsHeader(
      [CONTENT.CONTENT_ROYAL_HEADER_VN,
      CONTENT.CONTENT_ROYAL_HEADER_MENU_VN,
      CONTENT.CONTENT_ROYAL_FOOTER_VN
      ],
      [SETTING.royal_meta_tag_trang_chu_english]
    )

    const metaTags = header.settingValue[0]
    const CONTENT_ROYAL_HEADER_VN = header.contentValue.find(x => x.key == CONTENT.CONTENT_ROYAL_HEADER_VN);
    const CONTENT_ROYAL_HEADER_MENU_VN = header.contentValue.find(x => x.key == CONTENT.CONTENT_ROYAL_HEADER_MENU_VN);
    const CONTENT_ROYAL_FOOTER_VN = header.contentValue.find(x => x.key == CONTENT.CONTENT_ROYAL_FOOTER_VN);
    return {
      metaTags: metaTags.value,
      CONTENT_ROYAL_HEADER_VN: CONTENT_ROYAL_HEADER_VN.content,
      CONTENT_ROYAL_HEADER_MENU_VN: CONTENT_ROYAL_HEADER_MENU_VN.content,
      CONTENT_ROYAL_FOOTER_VN: CONTENT_ROYAL_FOOTER_VN.content,
    }
  }
  componentDidMount() {
    this.tagMenu();
    this.setSubmenu()
  }
  isAbsolutePath(path: string) {
    return path.indexOf("/") === 0;
  }

  isHashTag(path: string) {
    return path.indexOf("#") === 0;
  }

  tagMenu() {
    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (this) {
        // On-page links
        if (
          location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length
            ? target
            : $("[name=" + this.hash.slice(1) + "]");
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            //                    event.preventDefault();
            $("html, body").animate(
              {
                scrollTop: target.offset().top - 150
              },
              1000,
              function () {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                $target.focus();
                if ($target.is(":focus")) {
                  // Checking if the target was focused
                  return false;
                } else {
                  $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                  $target.focus(); // Set focus again
                }
              }
            );
          }
        }
      });
  }

  setSubmenu() {
    $(".menu-desktop ul#ja-cssmenu li").mouseover(function (this) {
      $(".menu-desktop ul#ja-cssmenu li").each(function (this) {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this).addClass("active2");
        }
      });
    });
    $(".menu-desktop ul#ja-cssmenu li").mouseout(function (this) {
      $(".menu-desktop ul#ja-cssmenu li").each(function (this) {
        if ($(this).hasClass("active2")) {
          $(this).removeClass("active2");
          $(this).addClass("active");
        }
      });
    });
  }

  closeMenu() {
    $("#sb-slidebar").attr("class", "sb-slidebar sb-right");
    $("#sb-site").attr("style", "");
    $("#openmenu").attr("style", "");
    $("#headerghim").css("left", "0");
  }

  render() {
    // let metaTags: any[] = []
    let metaTags: any[] = generateMetaTag(this.props.metaTags)
    let head
    if (!this.props.seo) {
      head = (
        <Head>
          {metaTags}
          <title>
            {this.props.title == null ? "Trường Song ngữ Quốc tế ROYAL SCHOOL" : `${this.props.title}`}
          </title>
        </Head>
      )
    } else {
      head = (
        <Head>
          {metaTags}
          <meta
            name="description"
            content={this.props.seo.moTa}
            key={'name:description'}
          />

          <meta property="og:title" content={this.props.seo.title} key={'property:og:title'} />
          <meta property="og:description" content={this.props.seo.moTa} key={'property:og:description'} />
          <meta property="og:image" content={loadImage(this.props.seo.hinh)} key={'property:og:image'} />
          <meta property="og:image:type" content="image/jpeg" key={'property:og:image:type'} />
          <meta property="og:image:width" content="600" key={'property:og:image:width'} />
          <meta property="og:image:height" content="315" key={'property:og:image:height'} />
          <meta property="og:image:alt" content={this.props.seo.title} key={'property:og:image:alt'} />
          <title>
            {`Trường Song ngữ Quốc tế ROYAL SCHOOL - ${this.props.title}`}
          </title>
        </Head>
      )
    }


    return (
      <React.Fragment>
        {head}
        <div id="sb-site">
          <ContentComponent content={this.props.CONTENT_ROYAL_HEADER_VN} />
          {this.props.children}
          <ContentComponent content={this.props.CONTENT_ROYAL_FOOTER_VN} />
        </div>
        <ContentComponent content={this.props.CONTENT_ROYAL_HEADER_MENU_VN} />

        <script
          dangerouslySetInnerHTML={{
            __html: `function scroll() {

          // browser window scroll (in pixels) after which the "back to top" link is shown
          var offset = 300,
            //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
            //offset_opacity = 1200,
            //duration of the top scrolling animation (in ms)
            scroll_top_duration = 700,
            //grab the "back to top" link
            $back_to_top = $('.cd-top')

          //hide or show the "back to top" link
          $(window).scroll(function() {
            if ($(this).scrollTop() > offset) {
              $back_to_top.addClass('cd-is-visible')
            } else {
              $back_to_top.removeClass('cd-is-visible cd-fade-out')
            }
            //if( $(this).scrollTop() > offset_opacity ) {
            //	$back_to_top.addClass('cd-fade-out');
            //}
            //alert('5678');
            if ($(this).scrollTop() > 455) {
              $('.navbar-fixed-top').addClass('show')
            } else {
              $('.navbar-fixed-top').removeClass('show')
            }
          })

          //smooth scroll to top
          $back_to_top.on('click', function(event) {
            event.preventDefault()
            $('body,html').animate({
                scrollTop: 0,
              },
              scroll_top_duration
            )
          })
        }

        $(document).ready(function() {
          scroll();
          $('[data-includeHTML]').each(function() {
            $(this).load($(this).attr('data-includeHTML'))
          })

        })
        `
          }}
        />
      </React.Fragment >
    )
  }

}
